import React, { useRef } from 'react';
import Link from './Link';

import cx from 'classnames';
import useIntersection from 'buena-suerte/lib/hooks/useIntersection';

const HeroTwoColumns = ({ columns = [] }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef, { once: false });

  if (!columns || columns.length !== 2) return;

  return (
    <section
      ref={intersectionRef}
      className={cx('x bt--dark-brown df fdc fdr--lg reveal', {
        revealed: isIntersected,
      })}
    >
      {columns.map(({ image, invertColor, title, cta }, index) => (
        <section className="pr hero__two-column">
          <Link {...cta}>
            <picture>
              <source
                srcSet={`${image.url}?w=2000&auto=format&q=100`}
                media="(min-width: 1200px)"
              />
              <source
                srcSet={`${image.url}?w=1200&auto=format&q=100`}
                media="(min-width: 1000px)"
              />
              <source
                srcSet={`${image.url}?w=800&auto=format&q=100`}
                media="(min-width: 600px)"
              />
              <img
                alt={image.alt}
                className="db"
                src={`${image.url}?w=600&auto=format&q=100`}
              />
            </picture>
          </Link>

          {(title || cta) && (
            <div
              className={cx('pa hero-text__two-column', {
                'text-warm': invertColor,
              })}
            >
              {title && <p className="serif--md serif--lg--lg pb1">{title}</p>}
              {cta && <Link {...cta} />}
            </div>
          )}
        </section>
      ))}
    </section>
  );
};

export default HeroTwoColumns;